// extracted by mini-css-extract-plugin
module.exports = {"modal":"Spinner_modal__qyHrx","modal-dialog":"Spinner_modal-dialog__27fz1","modal-content":"Spinner_modal-content__1uMjF"};